import { createFileRoute } from "@tanstack/react-router"

import StoresReport from "~/components/prototype/allocation-planning/reports/StoresReport"

export const Route = createFileRoute("/_auth/allocation/_layout/reports/stores")({
  component: StoresReport,
})
